'use client';

import { StatisticButton } from '@/components/feature-buttons/statistic-button';
import { OddsPageLayout, ViewEnum } from '@/types';
import { SportMatchModel } from '@nf/types/odds';
import { MyFavouritesMatchButton } from '@/features/my-favourites/components/my-favourites-match-button';
import { CashoutIcon } from '@/components/icons/cashout-icon';
import { SmpButton } from '@/features/single-match-parlay/components/smp-button';
import { StreamingControls } from '@/features/odds-page/streaming-controls';

interface MatchOptionProps {
	match: SportMatchModel;
	oddsPageLayout: OddsPageLayout;
}

/**
 * [Galaxy] Odds Page > Match Optoion
 * @description 此元件顯示於 all width 卡片式 & width < 1024 的清單式
 * @see ListMatchOption
 */
export const MatchOption = ({ match, oddsPageLayout }: MatchOptionProps) => {
	return (
		<div 
			className="match-option" 
			onClick={(event: React.MouseEvent) => event.stopPropagation()}
		>
			{
				oddsPageLayout === 'card' ? (
					<>
						<MyFavouritesMatchButton 
							matchId={match.MatchId} 
							time={match.Ktm || match.Etm} 
							sportType={match.GameID}
						/>
						<StreamingControls 
							match={match}
							oddsPageLayout={oddsPageLayout}
						/>

						{/* galaxy smp button */}
						<SmpButton 
							match={match}
							viewType={ViewEnum.galaxy}
							className="btn--smp"
						/>
						<CashoutIcon match={match} />
						<StatisticButton 
							match={match} 
							isNeedSetMatchId={true} 
						/>
					</>
				) : (
					<>
						<StreamingControls 
							match={match}
							oddsPageLayout={oddsPageLayout}
						/>
						<CashoutIcon match={match} />
						<StatisticButton 
							match={match} 
							isNeedSetMatchId={true} 
						/>
					</>
				)
			}		
		</div>
	);
};